/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_Tag_Delete_Confirm_Description_With_UsageInputs */



/**
* | output |
* | --- |
* | "This tag is currently assigned to {count} project(s). All assignments will be removed. This action cannot be undone." |
*
* @param {Project_Tag_Delete_Confirm_Description_With_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_delete_confirm_description_with_usage = /** @type {((inputs: Project_Tag_Delete_Confirm_Description_With_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Delete_Confirm_Description_With_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieses Tag ist derzeit ${i?.count} Projekt(en) zugewiesen. Alle Zuweisungen werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`This tag is currently assigned to ${i?.count} project(s). All assignments will be removed. This action cannot be undone.`)
});